import {Text} from '@/components-v2/atoms'
import {TextInput} from '@/components-v2/molecules'
import {useRewardPoints} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardPoints'

/** v2 "<n> points." input for points rewards. */
export const RewardPoints = ({promotionCondition, rewardIndex = 0}) => {
  const {pointsValue, isError, handlePointsChange} = useRewardPoints({promotionCondition, rewardIndex})

  return (
    <>
      <div className="max-w-[400px]">
        <TextInput
          type="number"
          value={pointsValue}
          placeholderText="0"
          onUpdate={handlePointsChange}
          error={isError ? 'Value Invalid' : undefined}
        />
      </div>
      <Text>points.</Text>
    </>
  )
}
